import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import Question from '../../types/Question';

import { apiHost } from '../../config';
import { post } from '../../lib/requests';
import getAllQuestions from '../../lib/apiClient/questions/getAll';

import LoginForm from '../../components/common/LoginForm/LoginForm';

import TestingIntroPage from './intro';
import TestingQuestionPage from './question/index';

const TestingPage = () => {
  const match = useRouteMatch();
  const history = useHistory();

  if (
    document.location.pathname !== '/testing/intro' &&
    document.location.pathname !== '/testing'
  ) {
    history.push('/testing/intro');
  }

  const [authorized, setAuthorized] = useState<boolean | undefined>(undefined);
  const [questions, setQuestions] = useState<Question[]>([]);

  const getQuestions = async () => {
    try {
      setQuestions(await getAllQuestions());
    } catch (error: any) {
      if (error.message === 'Forbidden') {
        alert(
          'Данный пользователь уже прошел тестирование или не является учеником',
        );
        history.push('/login');
      }
      if (error.message === 'Unauthorized') {
        history.push('/login');
      }
    }
  };

  const checkIfUserIsStudent = () => {
    post(`${apiHost}/api/middleware/check_if_user_is_student`, {})
      .then(() => {
        setAuthorized(true);
        if (questions.length === 0) getQuestions().then(() => {});
      })
      .catch(({ message }) => {
        if (message === 'Forbidden') {
          alert(
            'Данный пользователь уже прошел тестирование или не является учеником',
          );
        }
        history.push('/login');
      });
  };

  useEffect(checkIfUserIsStudent, []);

  if (authorized === undefined) return <div />;

  return (
    <>
      <Switch>
        <Route path={`${match.url}/intro`}>
          <TestingIntroPage />
        </Route>

        <Route path={`${match.url}/`} exact>
          <TestingQuestionPage questions={questions} />
        </Route>
      </Switch>

      {!authorized && (
        <LoginForm
          onSuccess={({ role }) => {
            if (role !== 1) {
              throw new Error('Войдите под учетной записью ученика');
            }

            setAuthorized(true);
            if (questions.length === 0) getQuestions().then(() => {});
          }}
        />
      )}
    </>
  );
};

export default TestingPage;
